import { useEffect, useState } from 'react'
import { supabase } from '@/shared/lib/supabase'
import { useAuth } from '@/shared/contexts/AuthContext'

/**
 * Lee profiles.role (tabla compartida) del usuario actual.
 * Solo para mostrar/ocultar UI: la autorizacion real la aplica la Edge Function.
 */
export function useIsSuperAdmin(): { isSuperAdmin: boolean; loading: boolean } {
  const { user } = useAuth()
  const [isSuperAdmin, setIsSuperAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    if (!user || !supabase) {
      setIsSuperAdmin(false)
      setLoading(false)
      return
    }
    setLoading(true)
    const client = supabase
    const load = async () => {
      try {
        const { data } = await client.from('profiles').select('role').eq('id', user.id).maybeSingle()
        if (!cancelled) setIsSuperAdmin(data?.role === 'super_admin')
      } catch {
        if (!cancelled) setIsSuperAdmin(false)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    void load()
    return () => {
      cancelled = true
    }
  }, [user])

  return { isSuperAdmin, loading }
}
